<template>
  <p>When writing your review, please consider the following guidelines:</p>
  <ul>
    <li>Focus on the product and your individual experience using it</li>
    <li>Provide details about why you liked or disliked a product</li>
    <li>
      All submitted reviews are subject to our <a :href="termsOfUse" target="_blank" class="link-body">Terms of Use</a> and our
      <a :href="userGeneratedContent" target="_blank" class="link-body">User Generated Content</a> policy
    </li>
  </ul>
  <p>We reserve the right not to post your review if it contains any of the following types of content or violates other guidelines:</p>
  <ul>
    <li>Obscenities, discriminatory language, or other language not suitable for a public forum</li>
    <li>Advertisements, “spam” content, or references to other products, offers, or websites</li>
    <li>Email addresses, URLs, phone numbers, physical addresses or other forms of contact information</li>
    <li>Critical or spiteful comments on other reviews posted on the page of their authors</li>
  </ul>
  <p>
    In addition, if you wish to share feedback with us about product selection, pricing, ordering, delivery or other customer service issues, please
    do not submit this feedback through a product review. Instead, <a :href="contactUs" target="_blank" class="link-body">contact us</a> directly.
  </p>
  <p>Enjoy writing your review!</p>
</template>

<script setup lang="ts">
import { customerServiceUrls } from 'config';

const { reviews } = customerServiceUrls;
const { termsOfUse, userGeneratedContent, contactUs } = reviews;
</script>
